import * as React from 'react';

import ModularOnboardingModuleRenderer from 'bundles/onboarding-common/module-renderers/ModularOnboardingModuleRenderer';
import type { PageConfig_ComponentConfig_PageConfig_ExperimentalComponent_Fragment as ExperimentalComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

const ExperimentalComponentModuleRenderer = ({
  pageConfigComponent,
}: {
  pageConfigComponent: ExperimentalComponent;
}) => {
  switch (pageConfigComponent.id) {
    case 'PageConfig_ModularOnboarding':
      return <ModularOnboardingModuleRenderer entrypoint="SEARCH" shouldShowSuccessMessageOnCompletion />;
    default:
      return null;
  }
};

export default ExperimentalComponentModuleRenderer;
